<script>
import DOMUtils from '@/utils/DOMUtils'

const FEATURES = []

export default
{
    name: 'screenshots-mockup',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        const isMobile = DOMUtils.getMatchingMediaName() == 'mobile'

        const feature = (title, description, screenshots) =>
        {
            const elem = (
                <div class='feature' on-click={e => this.onFeatureClicked(elem)}>
                    <div class='background' />
                    <div class='title'>{ title }</div>
                    <div class='description'>{ description }</div>
                </div>
            )

            if (!Array.isArray(screenshots)) screenshots = [screenshots]
            elem.screenshots = screenshots

            FEATURES.push(elem)

            return elem
        }

        const features =
        [
            feature('Actualités', 'Tenez vos citoyens au courant des dernières actualités, instantanément', [require('@/assets/img/screenshot-actualities-0.png'), require('@/assets/img/screenshot-actualities-1.png')]),
            feature('Événements', 'Attirez plus d\'attention sur les événements de votre ville', [require('@/assets/img/screenshot-events.png')]),
            feature('Signalements', 'Facilitez et optimisez les échanges entre la mairie et les citoyens', [require('@/assets/img/screenshot-reports-0.png'), require('@/assets/img/screenshot-reports-1.png')]),
            feature('Permissions', 'Créez plusieurs comptes avec des permissions définies pour travailler plus efficacement en équipe', [require('@/assets/img/screenshot-accounts.png')]),
            feature('Édition', 'Connectez-vous avec votre compte administrateur directement depuis l\'application pour modifier le contenu visible par vos citoyens', [require('@/assets/img/screenshot-edition-0.png'), require('@/assets/img/screenshot-edition-1.png')])
        ]

        return (
            <div class='screenshots-mockup'>
                <div class='features-list' v-show={!isMobile}>
                    { !isMobile && features.slice(0, (features.length) / 2 + 1) }
                </div>
                <div class='mockup' ref='mockup'>
                    <img class='screenshot' src={this.featureScreenshot || require('@/assets/img/screenshot-home.png')} />
                    <div class='shadow-caster' />
                </div>
                <div class='features-list' ref='mobileFeaturesList'>
                   { !isMobile && features.slice((features.length) / 2 + 1) }
                   { isMobile && features  }
                </div>
            </div>
        )
    },

    mounted ()
    {
        const startAutoFeatureSwitchInterval = setInterval(() =>
        {
            if (!DOMUtils.isElementVisible(this.$refs.mockup)) return
            clearInterval(startAutoFeatureSwitchInterval)

            setTimeout(() =>
            {
                if (!this.activeFeature) this.selectFeature(FEATURES[0])
            }, 2000);
        }, 1000);
    },

    data () 
    {
        return {
            activeFeature: null,
            featureScreenshots: [],
            featureScreenshotIdx: 0,
            nextScreenshotIdxInterval: null,
            anyFeatureHasBeenClicked: false
        }
    },

    computed:
    {
        featureScreenshot ()
        {
            return this.featureScreenshots[this.featureScreenshotIdx]
        }
    },

    methods:
    {
        onFeatureClicked (feature)
        {
            this.anyFeatureHasBeenClicked = true
            this.selectFeature(feature)
        },

        selectFeature (feature)
        {
            if (this.activeFeature)
            {
                this.activeFeature.elm.classList.remove('active')
                this.activeFeature.elm.classList.remove('progressing')
            }

            const startProgressEffect = () =>
            {
                if (feature.screenshots.length > 1 || !this.anyFeatureHasBeenClicked)
                {
                    feature.elm.classList.add('progressing')
                }
            }

            if (DOMUtils.getMatchingMediaName() == 'mobile')
            {
                const mobileFeaturesList = this.$refs.mobileFeaturesList
                mobileFeaturesList.scrollTo({ behavior: 'smooth', left: feature.elm.offsetLeft - mobileFeaturesList.offsetWidth / 2 + feature.elm.offsetWidth / 2 })
            }

            feature.elm.classList.add('active')
            startProgressEffect()
            this.activeFeature = feature
            this.featureScreenshots = feature.screenshots
            this.featureScreenshotIdx = 0

            clearInterval(this.nextScreenshotIdxInterval)
            this.nextScreenshotIdxInterval = setInterval(() =>
            {
                feature.elm.classList.remove('progressing')
                if (!this.anyFeatureHasBeenClicked && this.featureScreenshotIdx >= feature.screenshots.length - 1)
                {
                    this.nextFeature()
                }
                else
                {
                    setTimeout(() =>
                    {
                        this.nextScreenshotIndex()
                        startProgressEffect()
                    }, 50)
                }
            }, 6000)
        },

        nextScreenshotIndex ()
        {
            this.featureScreenshotIdx = ((this.featureScreenshotIdx || 0) + 1) % (this.featureScreenshots.length || 1)
        },

        nextFeature ()
        {
            const currentFeatureIdx = FEATURES.indexOf(this.activeFeature)
            this.selectFeature(FEATURES[ (currentFeatureIdx + 1) % FEATURES.length ])
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.screenshots-mockup
{
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .OnTablet({ flex-direction: row; });

    .mockup
    {
        width: 70%;
        margin-left: 15%;

        .OnTablet({ width: 30%; margin-left: 0; });
        .OnLarge({ width: 25%; });

        .screenshot
        {
            width: 100%;
        }

        .shadow-caster
        {
            width: 95%;
            margin-left: 2.5%;
            height: 120vw;
            margin-top: -195%;
            border-radius: 40px;
            box-shadow: 0 0 15px 10px #00000030;

            .OnTablet({ height: 45vw; });
            .OnDesktop({ height: 33vw; });
            .OnLarge({ height: 27vw; });
        }
    }

    .features-list
    {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-top: 30px;
        overflow: scroll;

        .OnTablet({
            flex-direction: column;
            width: 28%;
            margin-top: 0;
            overflow: hidden;
        });

        .feature
        {
            background-color: #00000004;
            border-radius: 6px;
            transition: all 0.2s ease-in-out;
            margin: 1vh 6px;
            padding: 1.4vh 3vw;
            position: relative;
            z-index: 1;
            cursor: pointer;
            flex-shrink: 0;
            width: 190px;

            .OnTablet({
                width: initial;
                padding: 2vh 2vw;
            });

            .OnDesktop({
                margin: 2vh 3px;
                padding: 3.5vh 1.5vw;
            });

            &:hover, &.active
            {
                box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
            }

            &.progressing
            {
                & .background
                {
                    width: 100%;
                    transition: width 6s linear;
                    background-color: rgba(0, 0, 0, 0.03);
                }
            }

            .background
            {
                position: absolute;
                z-index: -1;
                width: 0%;
                height: 100%;
                top: 0;
                left: 0;
                border-radius: 6px;
                transition: none;
            }

            .title
            {
                font-family: Nunito;
                font-weight: bold;
                margin-bottom: 0.5vh;
                font-size: 18px;

                .OnTablet({ font-size: 2.3vw; });
                .OnDesktop({ font-size: 1.4vw; });
                .OnLarge({ font-size: 1vw; });
            }

            .description
            {
                font-size: 15px;
                color: #000000c0;
                
                .OnDesktop({ font-size: 1vw; });
                .OnLarge({ font-size: 0.9vw; });
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ScreenshotsMockup.vue